import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { updateAssessment } from '../../app/store/assessmentSlice';
import { setAllAssessmentQuestionStatus, setAssessmentQuestionStatusFromPoll, setAssessmentStatus, setAuditLogs, setComments } from '../../app/store/questionnaireAnswerSlice';
import { AssessmentSurvey, AssessorAnswer } from '../../interfaces/assessment.interface';
import { Survey } from '../../interfaces/survey.interface';
import { fetchAssessment, getCommentsAndLogs } from '../../services/assessments';
import SurveyExperience from '../Surveys/Survey';
import { updateWorkflow } from '../../app/store/workflowSlice';
import { WORKFLOW_STATUSES } from '../../services/workflow';

export default function Assessment() {
  const dispatch = useAppDispatch();
  const params = useParams();
  const assessmentId:number = parseInt(params.assessmentId!);
  const [pollingBegun, setPollingBegun] = useState(false);
  const { user } = useAppSelector(state => state.user);
  const { assessment } = useAppSelector(state => state.assessments);
  const { assessmentQuestionsStatus, questionStatus, questions, auditLogs, bpStatus, bestPractice, certControlsById, assessmentStatus } = useAppSelector(state => state.questionnaireAnswer);
  const workflow = useAppSelector(state => state.workflow?.workflows?.find(wf => wf.assessment === assessment?.id));
  useEffect(() => {
    if (
      !assessmentId ||
      !bestPractice ||
      !certControlsById ||
      !Object.keys(questionStatus).length ||
      !Object.keys(bpStatus).length ||
      !bpStatus[Object.keys(bpStatus)[0]].id ||
      !assessmentQuestionsStatus ||
      !assessmentStatus ||
      ['Remediation', 'Complete', 'Completed'].indexOf(assessmentStatus) > -1 ||
      pollingBegun
    ) return;
    
    setPollingBegun(true);
  }, [assessmentId, bestPractice, certControlsById, questionStatus, bpStatus, assessmentQuestionsStatus, assessmentStatus]);

  useEffect(() => {
    if (!pollingBegun) return;
    const assessmentPoll = setInterval(() => {
      fetchAssessment(assessmentId).then(pollAssessment => {
        const assessmentSurvey = (pollAssessment.surveys as AssessmentSurvey[]).find(assSur => (assSur.survey as Survey).id === parseInt(params.surveyId as string));
        if (!assessmentSurvey) return;

        (assessmentSurvey.assessorAnswers as AssessorAnswer[]).forEach(aa => {
          const qid = typeof aa.question === 'number' ? aa.question : aa.question.id;
          if (!assessmentQuestionsStatus || (assessmentQuestionsStatus[qid] && assessmentQuestionsStatus[qid]?.id)) return;
          const curQ = questions?.find(q => q.id === qid);
          if (!curQ) return;
          dispatch(setAssessmentQuestionStatusFromPoll({
            ...aa,
            id: aa.id as number,
            question: curQ,
            status: aa.status!,
            contentOwnerPriority: aa.contentOwnerPriority as number[],
            assessorAnswer: aa.answer,
          }));
        });
        if (assessmentSurvey.status !== assessmentStatus) {
          dispatch(updateAssessment(pollAssessment));
          // Only 'Begin' proccess should update wf status to 'Assessing'Be
          if (workflow && pollAssessment.status !== WORKFLOW_STATUSES.ASSESSING) dispatch(updateWorkflow({ id: workflow.id, status: pollAssessment.status }));
        }
      });
    }, 10000);

    return () => {
      setPollingBegun(false);
      clearInterval(assessmentPoll);
    };
  }, [pollingBegun]);

  useEffect(() => {
    if (!assessment) return;
    const curSurvey = (assessment.surveys as AssessmentSurvey[]).find(assSur => (assSur.survey as Survey).id === parseInt(params.surveyId as string));
    if (!user) return;
    dispatch(setAssessmentStatus(curSurvey && curSurvey.status ? curSurvey.status : assessment.status));
    if (curSurvey && curSurvey.assessorAnswers && Object.keys(auditLogs).length === 0) {
      getCommentsAndLogs(curSurvey.assessorAnswers as AssessorAnswer[]).then(commentsAndLogs => {
        if (commentsAndLogs.comments && commentsAndLogs.comments.length > 0) dispatch(setComments(commentsAndLogs.comments));
        if (commentsAndLogs.auditLogs && commentsAndLogs.auditLogs.length > 0) dispatch(setAuditLogs(commentsAndLogs.auditLogs));
        const newAssessmentQuestionStatus = (curSurvey.assessorAnswers as AssessorAnswer[]).reduce(
          (obj, item) => Object.assign(obj, { [typeof item.question === 'number' ? item.question : item.question.id]: item }), {},
        );
        dispatch(setAllAssessmentQuestionStatus(
          newAssessmentQuestionStatus,
          {
            remediationQuestionAnswers: true,
            vendorStatus: true,
          },
        ));
      });
    }
  }, [assessment]);

  return (<SurveyExperience />);
}
